import React, { useState } from "react";
import { Images } from "../../../../assets/images";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
} from "@material-ui/core";
import { Actions, DropDown, Icon, Header, Heading } from "../styles";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import { sanitize } from "dompurify";

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: "none",
    border: `solid 0.5px #e1e3ee`,
  },
  content: {
    margin: `0 !important`,
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: `0 !important`,
    },
  },
  details: {
    display: "flex",
    flexDirection: "column",
    padding: `0 21px 21px !important`,
  },
}));

const CaseAgreement = ({
  title = "Final Award Summary for Case ID: 15372",
  message,
  summaryStatus = false,
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(true);
  return (
    <Accordion className={classes.root} expanded={expanded}>
      <AccordionSummary
        classes={{ content: classes.content }}
        onClick={() => setExpanded((e) => !e)}
      >
        <Header>
          <div className="title-container">
            <Heading size="12px" style={{ marginBottom: "unset" }}>
              {title}
            </Heading>
          </div>
          <Actions>
            <DropDown>
              <Icon
                src={Images.dropDownArrow}
                alt="dropdown"
                expanded={expanded}
              />
            </DropDown>
          </Actions>
        </Header>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <AggrementArea>
          {summaryStatus ? (
            <>
              <div
                dangerouslySetInnerHTML={{ __html: sanitize(message) }}
              ></div>
            </>
          ) : (
            <div className="no-summary">
              <div>{`You have reached a legally binding agreement. Please wait while we prepare your summary.`}</div>
            </div>
          )}
        </AggrementArea>
      </AccordionDetails>
    </Accordion>
  );
};

CaseAgreement.defaultProps = {
  message: `Agreement Summary is Preparing by IIAC Counsel`,
};

export default CaseAgreement;

const AggrementArea = styled.div`
  font-size: 14px;
  & .no-summary {
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    font-family: ${theme.fonts.primaryFontSemiBold};
    text-align: center;
    & div {
      width: 80%;
    }
  }
  & p {
    padding: 10px 0px;
    max-width: 480px;
    font-family: ${theme.fonts.primaryFontRegular};
  }
`;
